import { useState, createRef, createElement } from 'react';

function PreventBlur({
  children,
  element = 'span',
  selector = 'button, a',
  allowFocusSelector,
  onPointerDown,
  onMouseDown,
  onBlur,
  onKeyDown,
  nodeRef,
  ...props
}) {
  const [internalRef] = useState(() => /*#__PURE__*/createRef());
  return /*#__PURE__*/createElement(element, {
    ...props,
    onPointerDown: getPointerHandler(onPointerDown),
    onMouseDown: getPointerHandler(onMouseDown),
    onBlur: getBlurHandler(onBlur),
    ref: mergeRefs(nodeRef, internalRef)
  }, children);
  function getPointerHandler(handler) {
    return event => {
      const target = event.nativeEvent.target;
      const {
        activeElement
      } = document;
      const closestMatch = selector && target instanceof Element && target.closest(selector);
      if (activeElement instanceof HTMLElement && activeElement.contentEditable && closestMatch) {
        if (!allowFocusSelector || target.closest(allowFocusSelector) === null) {
          event.preventDefault();
        } else if (props.onFocus) {
          props.onFocus();
        }
      }
      handler === null || handler === void 0 ? void 0 : handler(event);
    };
  }
  function getBlurHandler(handler) {
    return event => {
      var _internalRef$current;
      const {
        target,
        relatedTarget
      } = event;
      if (!(target instanceof HTMLElement) || !(relatedTarget instanceof HTMLElement)) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        return;
      }
      // Focus is moving from one descendant to another, so the wrapped content still has focus. We don't want to
      // call onBlur in this case.
      const focusIsMovingWithin = ((_internalRef$current = internalRef.current) === null || _internalRef$current === void 0 ? void 0 : _internalRef$current.contains(relatedTarget)) && target && internalRef.current.contains(target);
      if (focusIsMovingWithin) {
        event.preventDefault();
        return;
      }
      handler === null || handler === void 0 ? void 0 : handler(event);
    };
  }
}
const mergeRefs = (...refs) => {
  return node => {
    for (const ref of refs) {
      if (ref) {
        ref.current = node;
      }
    }
  };
};

export { PreventBlur };
